import { MutationTree } from "vuex";
import { IProductionLineState } from "./state";
import {
    ADD_PRODUCTION_LINES,
    ADD_WORK_ORDERS,
    WORK_ORDERS_UPDATED,
    WORK_ORDER_UPDATED,
    ADD_NOTIFICATION,
    DELETE_NOTIFICATION,
    SET_LAST_CLEANINGS,
    ADD_LAST_CLEANING,
} from "./mutations-types";
import {
    IProductionLine,
    IWorkOrder,
    ICleaning,
    CleaningType,
} from "@/models";

export const mutations: MutationTree<IProductionLineState> = {

    [ADD_PRODUCTION_LINES](state, payload: IProductionLine[]): void {
        state.productionLines = state.productionLines.concat(payload);
    },

    [ADD_WORK_ORDERS](state, payload: IWorkOrder[]): void {
        state.workOrders = state.workOrders.concat(payload);
    },

    [WORK_ORDERS_UPDATED](state, payload: IWorkOrder[]): void {
        state.workOrders = payload;
    },

    [WORK_ORDER_UPDATED](state, payload: IWorkOrder): void {
        state.workOrders = state.workOrders.map(wo => {
            if (wo.workOrderId === payload.workOrderId) {
                return payload;
            }
            return wo;
        });
    },

    [ADD_NOTIFICATION](state, payload: string): void {
        state.notifications.push(payload);
    },

    [DELETE_NOTIFICATION](state, payload: number): void {
        state.notifications = state.notifications.filter((notification, index) => index !== payload );
    },

    [SET_LAST_CLEANINGS](state, payload: ICleaning[]): void {
        state.lastCleanings = payload;
    },

    [ADD_LAST_CLEANING](state, payload: ICleaning): void {
        state.lastCleanings = state.lastCleanings.filter(cleaning => cleaning.type !== payload.type);
        state.lastCleanings.push(payload);
    },
};
